export default __webpack_public_path__ + "6e655495c7229ebe810137ce6cac50b4.png";